"use client";

import Script from "next/script";

export default function UserJotWidget() {
  const projectId = process.env.NEXT_PUBLIC_USERJOT_PROJECT_ID;
  if (!projectId) return null;

  return (
    <Script
      id="userjot-widget"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          window.$ujq = window.$ujq || [];
          window.uj = window.uj || new Proxy({}, {
            get: (_, p) => (...a) => window.$ujq.push([p, ...a])
          });
          var s = document.createElement('script');
          s.src = 'https://cdn.userjot.com/sdk/v2/uj.js';
          s.type = 'module';
          s.async = true;
          document.head.appendChild(s);
          var isMobile = window.innerWidth < 768;
          window.uj.init('${projectId}', { widget: !isMobile });
        `,
      }}
    />
  );
}
